import React, { useState } from 'react';
import TimeSlot from './time_slot';
import DailyShiftPreviewTable from './daily_shift_preview_table';



export function AddDailyWorkingHour({ selectedDay, shiftData, onShiftDeleted, onShiftAdded, onSaveDailyWorkingHour }) {
  const [showTimeSlot, setShowTimeSlot] = useState(true);
  const [error, setError] = useState('');
  const [shiftPreviews, setShiftPreviews] = useState(shiftData || []);
  const [showAddTimeSlotButton, setShowAddTimeSlotButton] = useState(true);
  
  const checkIt = (previewData, indexToExclude = null) => {
    const overlappingShift = shiftPreviews.some((preview, index) => {
      if (index === indexToExclude) return false;
      return (
        (previewData.workStartTime > preview.workStartTime && previewData.workStartTime < preview.workEndTime) ||
        (previewData.workEndTime > preview.workStartTime && previewData.workEndTime < preview.workEndTime) ||
        (previewData.workStartTime < preview.workStartTime && previewData.workEndTime > preview.workEndTime )
      );
    });
    return overlappingShift;
  }

  const handleShiftPreview = (previewData, index = null) => {
    if (checkIt(previewData, index)) {
      setError("La nuova fascia oraria si sovrappone ad un orario già inserito.");
      return;
    }
  
    const updatedPreviews = [...shiftPreviews];
  
    if (index !== null) {
      updatedPreviews[index] = previewData;
    } else {
      updatedPreviews.push(previewData);
    }
  
    setShiftPreviews(updatedPreviews);
    setShowTimeSlot(false);
    setError('');

    if(selectedDay && onShiftAdded) {
      onShiftAdded(previewData);
    }
  };

  const handleDeleteShift = (index) => {
    const updatedPreviews = [...shiftPreviews];
    updatedPreviews.splice(index, 1);
    if(onShiftDeleted)
      onShiftDeleted(selectedDay || '', index)
    setShiftPreviews(updatedPreviews);
  };

  const handleHideTimeSlot = () => {
    setShowTimeSlot(false);
    setError('');
  };

  const handleAddNewSlotClick = () => {
    setShowTimeSlot(true);
    setError('');
  };

  const handleSave = () => {
    if (onSaveDailyWorkingHour) {
      onSaveDailyWorkingHour(shiftPreviews);     
    }
  };

  return (
    <div>
      <DailyShiftPreviewTable 
        shiftPreviews={shiftPreviews} 
        onShiftPreview={handleShiftPreview} 
        onDeleteShift={handleDeleteShift} 
      />

      {error && (
        <div className="my-2 mx-4 flex justify-center">
          <p className="text-red-500 text-sm">{error}</p>
        </div>
      )}
      {showTimeSlot && (
        <TimeSlot
          onShiftPreview={handleShiftPreview}
          onCancelEdit={handleHideTimeSlot}
        />
      )}
      <div className="flex justify-center my-4 mx-4">
        <div className="flex gap-4 w-full max-w-md">
          {!showTimeSlot && showAddTimeSlotButton && (
            <div className="flex-1">
              <button 
                onClick={handleAddNewSlotClick} 
                className="w-60 uppercase font-semibold bg-white text-gray-600 shadow-md border border-gray-200 text-sm px-4 py-2 rounded-md hover:bg-gray-200"
              >
                Aggiungi Fascia Oraria
              </button>
            </div>
          )}

          {shiftPreviews.length > 0 && (
            <div className="flex-1">
              <button
                onClick={handleSave}
                className="w-60 uppercase font-semibold bg-indigo-600 text-white text-sm px-4 py-2 rounded-md hover:bg-indigo-500"
              >
                Salva
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
